<div class="activity-card">
  <div class="activity-header">
    <h3 class="activity-title">Recent Activity</h3>
    <a href="#" class="view-all">
      View all
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <line x1="5" y1="12" x2="19" y2="12" />
        <polyline points="12 5 19 12 12 19" />
      </svg>
    </a>
  </div>
  <div class="activity-list">
    <div
      class="activity-item"
      *ngFor="let activity of activities; let i = index"
      [style.animation-delay]="i * 0.1 + 's'"
    >
      <div
        class="activity-dot"
        [class.created]="activity.actionType === 'created'"
        [class.approved]="activity.actionType === 'approved'"
      ></div>
      <div class="activity-content">
        <p class="activity-text">
          <span class="activity-user">{{ activity.user }}</span>
          <span
            class="activity-action"
            [class.created]="activity.actionType === 'created'"
            [class.approved]="activity.actionType === 'approved'"
          >
            {{ activity.action }}
          </span>
          <span class="activity-target">{{ activity.target }}</span>
        </p>
        <span class="activity-time">{{ activity.date }}, {{ activity.time }}</span>
      </div>
    </div>
  </div>
</div>

